import styled from "styled-components";
import backgroundUrl from '../static/Images/blackholeV1.webp'
import backgroundUrlV2 from '../static/Images/blackholeV2.webp'
export const BgImage50 = styled.div`

    background-image: url(${backgroundUrl});
    position: relative;
    height: 75vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

export const BgImage25 = styled.div`

    background-image: url(${backgroundUrl});
    position: relative;
    height: 15vh;
    display: flex;

`;

export const BgImage25Top = styled.div`

    background-image: url(${backgroundUrlV2});
    position: relative;
    height: 25vh;
    background-position: 0% 20%;
    background-repeat: no-repeat;
    background-size: cover;
`;
